<div class="overlay-push-configs d-flex h-100 flex-column">
    <div class="overlay-push-configs-header d-flex flex-column">
        <button (click)="selectOverlay('notifications')" class="btn btn-close" type="button">
            <i class="icon icon-edponline-Bop-078 icon-2x rotate-180" aria-hidden="true"></i>
        </button>

        <h2 [innerHTML]="'pt.edp.edponline.overlay.push.configs.title' | translate"></h2>
    </div>

    <div class="overlay-push-configs-body" >
        <div class="d-flex flex-column channel-section">
            <span class="title">{{"pt.edp.edponline.overlay.push.configs.channel" | translate}}</span>
            <edp-input-toogle
                [title]="'pt.edp.edponline.overlay.push.configs.channel.WEB' | translate"
                [toogleValue]="getOptionStatus('CHANNEL', 'WEB')"
                (checked)="setOption($event, 'CHANNEL', 'WEB')"
                [sufix]="'-channel-WEB'"
            ></edp-input-toogle>

            <edp-input-toogle
                [title]="'pt.edp.edponline.overlay.push.configs.channel.PUSH' | translate"
                [toogleValue]="getOptionStatus('CHANNEL', 'PUSH')"
                (checked)="setOption($event, 'CHANNEL', 'PUSH')"
                [sufix]="'-channel-PUSH'"
            ></edp-input-toogle>

        </div>

        <div class="d-flex flex-column push-section">
            <div class="d-flex flex-md-column flex-row type-header">
                <span class="title">{{"pt.edp.edponline.overlay.push.configs.notification.type" | translate}}</span>

                <div class="select-all">
                    <edp-input-toogle
                        [title]="'pt.edp.edponline.overlay.push.configs.notification.all' | translate"
                        [toogleValue]="selectedAll"
                        (checked)="setAll($event)"
                        [sufix]="'-all'"
                    ></edp-input-toogle>
                </div>
            </div>

            <!-- FATURACAO -->
            <div class="d-flex flex-column" *ngIf="pushConfigs?.PAYMENTS">
                <span class="subtitle">
                    {{"pt.edp.edponline.overlay.push.configs.payments" | translate}}
                </span>

                <edp-input-toogle
                    [title]="'pt.edp.edponline.overlay.push.configs.available.invoices' | translate"
                    [toogleValue]="getOptionStatus('PAYMENTS', 'PAYMENT')"
                    (checked)="setOption($event, 'PAYMENTS', 'PAYMENT')"
                    [sufix]="'-payments-PAYMENT'"
                ></edp-input-toogle>

                <edp-input-toogle
                    *ngIf="!hasDD"
                    [title]="'pt.edp.edponline.overlay.push.configs.payment.date' | translate"
                    [toogleValue]="getOptionStatus('PAYMENTS', 'DLP')"
                    (checked)="setOption($event, 'PAYMENTS', 'DLP')"
                    [sufix]="'-payments-DLP'"
                ></edp-input-toogle>

                <edp-input-toogle
                    [title]="'pt.edp.edponline.overlay.push.configs.outstanding invoices' | translate"
                    [toogleValue]="getOptionStatus('PAYMENTS', 'DEBT')"
                    (checked)="setOption($event, 'PAYMENTS', 'DEBT')"
                    [sufix]="'-payments-DEBT'"
                ></edp-input-toogle>
            </div>

             <!-- LEITURAS -->
             <div class="d-flex flex-column" *ngIf="pushConfigs?.READINGS">
                <span class="subtitle">
                    {{"pt.edp.edponline.overlay.push.configs.readings" | translate}}
                </span>

                <edp-input-toogle
                    [title]="'pt.edp.edponline.overlay.push.configs.readings.period' | translate"
                    [toogleValue]="getOptionStatus('READINGS', 'IDEAL_READING_DATE')"
                    (checked)="setOption($event, 'READINGS', 'IDEAL_READING_DATE')"
                    [sufix]="'-readings'"
                ></edp-input-toogle>
            </div>

            <!-- GESTOR ENERGIA -->
            <div class="d-flex flex-column" *ngIf="pushConfigs?.MANAGERS && enableGeSession()">
                <span class="subtitle">
                    {{"pt.edp.edponline.overlay.push.configs.energy" | translate}}
                </span>

                <edp-input-toogle
                    [title]="'pt.edp.edponline.overlay.push.configs.energy.FAIL' | translate"
                    [toogleValue]="getOptionStatus('MANAGERS', 'FAIL')"
                    (checked)="setOption($event, 'MANAGERS', 'FAIL')"
                    [sufix]="'-energy-FAIL'"
                ></edp-input-toogle>
                <edp-input-toogle
                    [title]="'pt.edp.edponline.overlay.push.configs.energy.PREVIEW' | translate"
                    [toogleValue]="getOptionStatus('MANAGERS', 'PREVIEW')"
                    (checked)="setOption($event, 'MANAGERS', 'PREVIEW')"
                    [sufix]="'-energy-PREVIEW'"
                ></edp-input-toogle>
                <edp-input-toogle
                    [title]="'pt.edp.edponline.overlay.push.configs.energy.ATYPICAL' | translate"
                    [toogleValue]="getOptionStatus('MANAGERS', 'ATYPICAL')"
                    (checked)="setOption($event, 'MANAGERS', 'ATYPICAL')"
                    [sufix]="'-energy-ATYPICAL'"
                ></edp-input-toogle>
            </div>
        </div>
    </div>
</div>
